function isIE() {
  return !!window.ActiveXObject || 'ActiveXObject' in window
}

function isIE11() {
  return (/Trident\/7\./).test(navigator.userAgent)
}

function safeRemove(dom) {
  if (!dom) {
    return
  }
  if (isIE() || isIE11()) {
    dom.removeNode(true)
  } else {
    dom.remove()
  }
}

function addEvent(element, type, callback) {
  if (!element) {
    return
  }
  if (element.addEventListener) {
    element.addEventListener(type, callback, false)
  } else if (element.attachEvent) {
    element.attachEvent('on' + type, callback)
  } else {
    element['on' + type] = callback
  }
}

function runOnce(fn) {
  var called = false
  return function () {
    if (called) {
      return
    }
    called = true
    fn()
  }
}

function iframeLoadFallback(callback) {
  setTimeout(callback, 80)
}

function PrintArea(option) {
  this.standards = {
    strict: 'strict',
    loose: 'loose',
    html5: 'html5'
  }
  this.previewBody = null
  this.close = null
  this.previewBodyUtilPrintBtn = null
  this.selectArray = []
  this.counter = 0
  this.settings = {
    standard: this.standards.html5
  }
  for (var key in option) {
    if (Object.prototype.hasOwnProperty.call(option, key)) {
      this.settings[key] = option[key]
    }
  }
  this.init()
}

PrintArea.prototype.init = function () {
  this.counter++
  this.settings.id = 'printArea_' + this.counter
  var url = ''
  if (this.settings.url && !this.settings.asyncUrl) {
    url = this.settings.url
  }
  var that = this
  if (this.settings.asyncUrl) {
    this.settings.asyncUrl(function (asyncUrl) {
      var printWindow = that.getPrintWindow(asyncUrl || that.getLocalFrameUrl())
      if (!asyncUrl) {
        that.write(printWindow.doc)
      }
      if (that.settings.preview) {
        that.previewIframeLoad()
      } else {
        that.print(printWindow)
      }
    }, this.settings.vue)
    return
  }
  var printWindow = this.getPrintWindow(url || this.getLocalFrameUrl())
  if (!this.settings.url) {
    this.write(printWindow.doc)
  }
  if (this.settings.preview) {
    this.previewIframeLoad()
  } else {
    this.print(printWindow)
  }
}

PrintArea.prototype.getLocalFrameUrl = function () {
  return 'about:blank'
}

PrintArea.prototype.previewIframeLoad = function () {
  var box = document.getElementById('vue-pirnt-nb-previewBox')
  if (!box) {
    return
  }
  var that = this
  var iframe = box.querySelector('iframe')
  this.settings.previewBeforeOpenCallback()
  var showPreview = runOnce(function () {
    that.previewBoxShow()
    that.removeCanvasImg()
    that.settings.previewOpenCallback()
  })
  addEvent(iframe, 'load', showPreview)
  iframeLoadFallback(showPreview)
  addEvent(box.querySelector('.previewBodyUtilPrintBtn'), 'click', function () {
    that.settings.beforeOpenCallback()
    that.settings.openCallback()
    iframe.contentWindow.print()
    that.settings.closeCallback()
  })
}

PrintArea.prototype.removeCanvasImg = function () {
  try {
    if (!this.elsdom) {
      return
    }
    var canvasList = this.elsdom.querySelectorAll('.canvasImg')
    for (var i = 0; i < canvasList.length; i++) {
      safeRemove(canvasList[i])
    }
  } catch (e) {
    console.log(e)
  }
}

PrintArea.prototype.print = function (printWindow) {
  var that = this
  var iframe = document.getElementById(this.settings.id) || printWindow.f
  var iframeWin = iframe.contentWindow || printWindow.f.contentWindow
  var startPrint = runOnce(function () {
    var cleanup = runOnce(function () {
      safeRemove(iframe)
      that.settings.closeCallback()
      that.removeCanvasImg()
    })
    addEvent(iframeWin, 'afterprint', cleanup)
    iframeWin.focus()
    that.settings.openCallback()
    iframeWin.print()
    // Chromium normally dispatches afterprint. Keep a final cleanup fallback
    // without tearing down the iframe while the dialog is still open.
    setTimeout(cleanup, 60000)
  })
  this.settings.beforeOpenCallback()
  startPrint()
}

PrintArea.prototype.write = function (printDocument) {
  printDocument.open()
  printDocument.write(this.docType() + '<html>' + this.getHead() + this.getBody() + '</html>')
  printDocument.close()
}

PrintArea.prototype.docType = function () {
  if (this.settings.standard === this.standards.html5) {
    return '<!DOCTYPE html>'
  }
  var transitional = this.settings.standard === this.standards.loose ? ' Transitional' : ''
  var dtd = this.settings.standard === this.standards.loose ? 'loose' : 'strict'
  return '<!DOCTYPE HTML PUBLIC "-//W3C//DTD HTML 4.01' + transitional + '//EN" "http://www.w3.org/TR/html4/' + dtd + '.dtd">'
}

PrintArea.prototype.getHead = function () {
  var extraHead = ''
  var links = ''
  var style = ''
  if (this.settings.extraHead) {
    this.settings.extraHead.replace(/([^,]+)/g, function (match) {
      extraHead += match
    })
  }
  ;[].forEach.call(document.querySelectorAll('link'), function (item) {
    if (item.href.indexOf('.css') >= 0) {
      links += '<link type="text/css" rel="stylesheet" href="' + item.href + '" >'
    }
  })
  var domStyle = document.styleSheets
  if (domStyle && domStyle.length > 0) {
    for (var i = 0; i < domStyle.length; i++) {
      try {
        if (domStyle[i].cssRules || domStyle[i].rules) {
          var rules = domStyle[i].cssRules || domStyle[i].rules
          for (var j = 0; j < rules.length; j++) {
            style += rules[j].cssText
          }
        }
      } catch (e) {
        console.log(domStyle[i].href + e)
      }
    }
  }
  if (this.settings.extraCss) {
    this.settings.extraCss.replace(/([^,\s]+)/g, function (match) {
      links += '<link type="text/css" rel="stylesheet" href="' + match + '">'
    })
  }
  return '<head><title>' + (this.settings.popTitle || '') + '</title><link rel="icon" href="data:,">' + extraHead + links + '<style type="text/css">' + style + '</style></head>'
}

PrintArea.prototype.getBody = function () {
  var ids = this.settings.ids
  ids = ids.replace(new RegExp('#', 'g'), '')
  this.elsdom = this.beforeHandler(document.getElementById(ids))
  var ele = this.getFormData(this.elsdom)
  return '<body>' + ele.outerHTML + '</body>'
}

PrintArea.prototype.beforeHandler = function (elsdom) {
  var canvasList = elsdom.querySelectorAll('canvas')
  for (var i = 0; i < canvasList.length; i++) {
    if (!canvasList[i].style.display) {
      var parent = canvasList[i].parentNode
      var canvasUrl = canvasList[i].toDataURL('image/png')
      var img = new Image()
      img.className = 'canvasImg'
      img.style.display = 'none'
      img.src = canvasUrl
      parent.appendChild(img)
    }
  }
  return elsdom
}

PrintArea.prototype.getFormData = function (ele) {
  var copy = ele.cloneNode(true)
  var copiedInputs = copy.querySelectorAll('input,select,textarea')
  var canvasImgList = copy.querySelectorAll('.canvasImg,canvas')
  var selectCount = -1
  for (var i = 0; i < canvasImgList.length; i++) {
    var parent = canvasImgList[i].parentNode
    var item = canvasImgList[i]
    if (item.tagName.toLowerCase() === 'canvas') {
      parent.removeChild(item)
    } else {
      item.style.display = 'block'
    }
  }
  for (var j = 0; j < copiedInputs.length; j++) {
    var input = copiedInputs[j]
    var typeInput = input.getAttribute('type')
    var copiedInput = copiedInputs[j]
    if (!typeInput) {
      typeInput = input.tagName === 'SELECT' ? 'select' : (input.tagName === 'TEXTAREA' ? 'textarea' : '')
    }
    if (input.tagName === 'INPUT') {
      if (typeInput === 'radio' || typeInput === 'checkbox') {
        if (input.checked) {
          copiedInput.setAttribute('checked', input.checked)
        }
      } else {
        copiedInput.value = input.value
        copiedInput.setAttribute('value', input.value)
      }
    } else if (typeInput === 'select') {
      selectCount++
      var originalSelects = ele.querySelectorAll('select')
      for (var k = 0; k < originalSelects.length; k++) {
        var select = originalSelects[k]
        if (!select.getAttribute('newbs')) {
          select.setAttribute('newbs', k)
        }
        if (select.getAttribute('newbs') == selectCount) {
          var selectedIndex = originalSelects[selectCount].selectedIndex
          input.options[selectedIndex].setAttribute('selected', true)
        }
      }
    } else {
      copiedInput.innerHTML = input.value
      copiedInput.setAttribute('html', input.value)
    }
  }
  return copy
}

PrintArea.prototype.getPrintWindow = function (url) {
  var iframe = this.Iframe(url)
  return {
    f: iframe,
    win: iframe.contentWindow || iframe,
    doc: iframe.doc
  }
}

PrintArea.prototype.previewBoxShow = function () {
  var box = document.getElementById('vue-pirnt-nb-previewBox')
  if (!box) {
    return
  }
  document.querySelector('html').setAttribute('style', 'overflow: hidden')
  box.style.display = 'block'
}

PrintArea.prototype.previewBoxHide = function () {
  var box = document.getElementById('vue-pirnt-nb-previewBox')
  if (!box) {
    return
  }
  document.querySelector('html').setAttribute('style', 'overflow: visible;')
  var iframe = box.querySelector('iframe')
  if (iframe) {
    safeRemove(iframe)
  }
  box.style.display = 'none'
}

PrintArea.prototype.previewBox = function () {
  var box = document.getElementById('vue-pirnt-nb-previewBox')
  var previewBodyClass = 'previewBody'
  if (box) {
    var cachedIframe = box.querySelector('iframe')
    if (cachedIframe) {
      safeRemove(cachedIframe)
    }
    return {
      close: box.querySelector('.previewClose'),
      previewBody: box.querySelector('.' + previewBodyClass)
    }
  }
  var previewContent = document.createElement('div')
  previewContent.setAttribute('id', 'vue-pirnt-nb-previewBox')
  previewContent.setAttribute('style', 'position: fixed;top: 0px;left: 0px;width: 100%;height: 100%;background: white;display:none')
  previewContent.style.zIndex = this.settings.zIndex

  var previewHeader = document.createElement('div')
  previewHeader.setAttribute('class', 'previewHeader')
  previewHeader.setAttribute('style', 'padding: 5px 20px;')
  previewHeader.innerHTML = this.settings.previewTitle
  previewContent.appendChild(previewHeader)

  this.close = document.createElement('div')
  var close = this.close
  close.setAttribute('class', 'previewClose')
  close.setAttribute('style', 'position: absolute;top: 5px;right: 20px;width: 25px;height: 20px;cursor: pointer;')
  var closeBefore = document.createElement('div')
  var closeAfter = document.createElement('div')
  closeBefore.setAttribute('class', 'closeBefore')
  closeBefore.setAttribute('style', 'position: absolute;width: 3px;height: 100%;background: #040404;transform: rotate(45deg); top: 0px;left: 50%;')
  closeAfter.setAttribute('class', 'closeAfter')
  closeAfter.setAttribute('style', 'position: absolute;width: 3px;height: 100%;background: #040404;transform: rotate(-45deg); top: 0px;left: 50%;')
  close.appendChild(closeBefore)
  close.appendChild(closeAfter)
  previewHeader.appendChild(close)

  this.previewBody = document.createElement('div')
  var previewBody = this.previewBody
  previewBody.setAttribute('class', previewBodyClass)
  previewBody.setAttribute('style', 'display: flex;flex-direction: column; height: 100%;')
  previewContent.appendChild(previewBody)

  var previewBodyUtil = document.createElement('div')
  previewBodyUtil.setAttribute('class', 'previewBodyUtil')
  previewBodyUtil.setAttribute('style', 'height: 32px;background: #474747;position: relative;')
  previewBody.appendChild(previewBodyUtil)

  this.previewBodyUtilPrintBtn = document.createElement('div')
  var previewBodyUtilPrintBtn = this.previewBodyUtilPrintBtn
  previewBodyUtilPrintBtn.setAttribute('class', 'previewBodyUtilPrintBtn')
  previewBodyUtilPrintBtn.innerHTML = this.settings.previewPrintBtnLabel
  previewBodyUtilPrintBtn.setAttribute('style', 'position: absolute;padding: 2px 10px;margin-top: 3px;left: 24px;font-size: 14px;color: white;cursor: pointer;background-color: rgba(0,0,0,.12);background-image: linear-gradient(hsla(0,0%,100%,.05),hsla(0,0%,100%,0));background-clip: padding-box;border: 1px solid rgba(0,0,0,.35);border-color: rgba(0,0,0,.32) rgba(0,0,0,.38) rgba(0,0,0,.42);box-shadow: inset 0 1px 0 hsla(0,0%,100%,.05), inset 0 0 1px hsla(0,0%,100%,.15), 0 1px 0 hsla(0,0%,100%,.05);')
  previewBodyUtil.appendChild(previewBodyUtilPrintBtn)

  document.body.appendChild(previewContent)

  return {
    close: this.close,
    previewBody: this.previewBody
  }
}

PrintArea.prototype.iframeBox = function (frameId, url) {
  var iframe = document.createElement('iframe')
  iframe.style.border = '0px'
  iframe.style.position = 'absolute'
  iframe.style.width = '0px'
  iframe.style.height = '0px'
  iframe.style.right = '0px'
  iframe.style.top = '0px'
  iframe.setAttribute('id', frameId)
  iframe.setAttribute('src', url)
  return iframe
}

PrintArea.prototype.Iframe = function (url) {
  var frameId = this.settings.id
  var iframeUrl = url || this.getLocalFrameUrl()
  var that = this
  var iframe = this.iframeBox(frameId, iframeUrl)
  try {
    if (!this.settings.preview) {
      document.body.appendChild(iframe)
    } else {
      iframe.setAttribute('style', 'border: 0px;flex: 1;')
      var previewBox = this.previewBox()
      previewBox.previewBody.appendChild(iframe)
      addEvent(previewBox.close, 'click', function () {
        that.previewBoxHide()
      })
    }
    iframe.doc = iframe.contentDocument ? iframe.contentDocument : (iframe.contentWindow ? iframe.contentWindow.document : iframe.document)
  } catch (e) {
    throw new Error(e + '. iframes may not be supported in this browser.')
  }
  if (iframe.doc == null) {
    throw new Error('Cannot find document.')
  }
  return iframe
}

var PrintDirective = {
  directiveName: 'print',
  bind: function (el, binding, vnode) {
    var vue = vnode.context
    var id = ''
    addEvent(el, 'click', function () {
      vue.$nextTick(function () {
        var bindingValue = binding && binding.value
        if (bindingValue && bindingValue.clickMounted) {
          bindingValue.clickMounted(vue)
        }
        if (typeof bindingValue === 'string') {
          id = bindingValue
          localPrint(bindingValue)
          return
        }
        if (bindingValue && typeof bindingValue === 'object' && bindingValue.id) {
          id = bindingValue.id
          var ids = id.replace(new RegExp('#', 'g'), '')
          var elsdom = document.getElementById(ids)
          if (!elsdom) {
            console.log('id in Error')
            id = ''
          }
          localPrint(bindingValue)
          return
        }
        if (bindingValue && bindingValue.preview) {
          localPrint(bindingValue)
          return
        }
        window.print()
      })
    })

    function localPrint(bindingValue) {
      new PrintArea({
        ids: id,
        vue: vue,
        url: bindingValue && bindingValue.url,
        standard: '',
        extraHead: bindingValue && bindingValue.extraHead,
        extraCss: bindingValue && bindingValue.extraCss,
        previewTitle: bindingValue && bindingValue.previewTitle ? bindingValue.previewTitle : '打印预览',
        zIndex: bindingValue && bindingValue.zIndex ? bindingValue.zIndex : 20002,
        previewPrintBtnLabel: bindingValue && bindingValue.previewPrintBtnLabel ? bindingValue.previewPrintBtnLabel : '打印',
        popTitle: bindingValue && bindingValue.popTitle,
        preview: !!(bindingValue && bindingValue.preview),
        asyncUrl: bindingValue && bindingValue.asyncUrl,
        previewBeforeOpenCallback: function () {
          if (bindingValue && bindingValue.previewBeforeOpenCallback) {
            bindingValue.previewBeforeOpenCallback(vue)
          }
        },
        previewOpenCallback: function () {
          if (bindingValue && bindingValue.previewOpenCallback) {
            bindingValue.previewOpenCallback(vue)
          }
        },
        openCallback: function () {
          if (bindingValue && bindingValue.openCallback) {
            bindingValue.openCallback(vue)
          }
        },
        closeCallback: function () {
          if (bindingValue && bindingValue.closeCallback) {
            bindingValue.closeCallback(vue)
          }
        },
        beforeOpenCallback: function () {
          if (bindingValue && bindingValue.beforeOpenCallback) {
            bindingValue.beforeOpenCallback(vue)
          }
        }
      })
    }
  }
}

PrintDirective.install = function (Vue) {
  Vue.directive('print', PrintDirective)
}

export default PrintDirective



// WEBPACK FOOTER //
// ./src/plugins/print-compatible.js